var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScaricaAppPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.208,
    height: 88.515,
    viewBox: "0 0 58.208 88.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9303",
    "data-name": "Raggruppa 9303",
    transform: "translate(-806.402 -1175.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icone_big_telefono_nero",
    "data-name": "icone/big/telefono/nero",
    transform: "translate(778.3 1169.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prestito-online",
    transform: "translate(28.102 6.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M54.708,60.476,21.519,71.931a1.333,1.333,0,0,1-1.585-.98L.215,13.258a1.325,1.325,0,0,1,.627-1.721L34.061.06a1.34,1.34,0,0,1,1.592.98L55.372,58.733a1.333,1.333,0,0,1-.664,1.743Z",
    transform: "translate(1.28 1.354)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_-_Contorno",
    "data-name": "Path - Contorno",
    d: "M21.609,73.727a2.709,2.709,0,0,1-2.616-1.994L-.695,14.132A2.7,2.7,0,0,1,.612,10.679a1.385,1.385,0,0,1,.161-.067L33.992-.864a1.38,1.38,0,0,1,.149-.042A2.721,2.721,0,0,1,37.358,1.02l19.689,57.6a2.73,2.73,0,0,1-1.378,3.489,1.383,1.383,0,0,1-.167.064L22.352,73.619a1.382,1.382,0,0,1-.149.042A2.725,2.725,0,0,1,21.609,73.727ZM1.89,13.151l.015.042L21.624,70.886q.009.027.017.055L54.465,59.612q-.01-.025-.018-.05L34.728,1.869q-.01-.028-.018-.057Z",
    transform: "translate(0.898 0.972)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M40.244,12.8a1.382,1.382,0,0,1,1.308.935L54.707,52.223a1.382,1.382,0,0,1-.861,1.755L18.376,66.1a1.382,1.382,0,0,1-1.755-.861L3.466,26.75A1.382,1.382,0,0,1,4.327,25L39.8,12.872A1.38,1.38,0,0,1,40.244,12.8Zm11.4,39.011L39.383,15.935,6.529,27.163,18.79,63.038Z",
    transform: "translate(-0.662 -4.036)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M15.1,19.276a1.382,1.382,0,0,1-.447-2.69l19.193-6.562a1.382,1.382,0,1,1,.894,2.615L15.544,19.2A1.38,1.38,0,0,1,15.1,19.276Z",
    transform: "translate(-4.416 -3)",
    fill: "#e02027"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.802,
    cy: 2.802,
    r: 2.802,
    transform: "translate(34.405 58.344)",
    fill: "#e02027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval-2",
    "data-name": "Oval",
    d: "M22.65,0C35.16,0,45.3,1.729,45.3,3.862S35.16,7.723,22.65,7.723,0,5.994,0,3.862,10.141,0,22.65,0Z",
    transform: "translate(12.907 80.792)",
    fill: "#aa001c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaricaAppPhone);
export default __webpack_public_path__ + "static/media/scarica-app-phone.ce8f4f3d28a47d5001bcd2596629f2c1.svg";
export { ForwardRef as ReactComponent };